import React from 'react';
import { Box } from '@mui/material';
import { theme, responsiveSpacing } from '../../theme/theme';
import ZiweiIntroduction from '../../components/ZiweiIntroduction';

const IntroductionScreen: React.FC = () => {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      backgroundColor: theme.colors.background,
      padding: responsiveSpacing.container
    }}>
      <ZiweiIntroduction />
    </Box>
  );
};

export default IntroductionScreen;